import React, { useState } from 'react'
import { toast } from 'react-hot-toast'
import { useAuth } from '../AuthContext'
import api from '../api'
import { X, LogIn, UserPlus, Eye, EyeOff } from 'lucide-react'

export default function LoginModal({ onClose }) {
  const { login } = useAuth()
  const [mode, setMode] = useState('login')
  const [form, setForm] = useState({ username: '', password: '', email: '' })
  const [loading, setLoading] = useState(false)
  const [showPw, setShowPw] = useState(false)

  const update = (k, v) => setForm(f => ({ ...f, [k]: v }))

  const handleLogin = async () => {
    if (!form.username || !form.password) return toast.error('Vui lòng nhập đầy đủ thông tin')
    setLoading(true)
    try {
      await login(form.username, form.password)
      toast.success('Đăng nhập thành công!')
      onClose()
    } catch (e) {
      toast.error(e.response?.data?.error || 'Đăng nhập thất bại')
    } finally { setLoading(false) }
  }

  const handleRegister = async () => {
    if (!form.username || !form.password) return toast.error('Vui lòng nhập đầy đủ thông tin')
    if (form.username.length < 3) return toast.error('Tên đăng nhập tối thiểu 3 ký tự')
    setLoading(true)
    try {
      await api.post('/auth/register', form)
      toast.success('Đăng ký thành công! Vui lòng đăng nhập.')
      setMode('login')
      setForm(f => ({ ...f, password: '' }))
    } catch (e) {
      toast.error(e.response?.data?.error || 'Đăng ký thất bại')
    } finally { setLoading(false) }
  }

  const onKey = (e) => {
    if (e.key === 'Enter') mode === 'login' ? handleLogin() : handleRegister()
  }

  return (
    <div
      className="modal-backdrop"
      onClick={e => e.target === e.currentTarget && onClose()}
    >
      <div className="modal-box">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="font-display text-lg text-[var(--accent)]">
              {mode === 'login' ? '🔐 Đăng nhập' : '📝 Đăng ký tài khoản'}
            </h2>
            <p className="text-[10px] text-[var(--text3)] mt-0.5">TranAnhWebTool</p>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-lg text-[var(--text3)] hover:text-[var(--text)]
              hover:bg-[var(--panel2)] transition-colors"
          >
            <X size={18} />
          </button>
        </div>

        {/* Tab switcher */}
        <div className="tab-bar mb-6">
          <div
            className={`tab-item flex-1 text-center ${mode === 'login' ? 'active' : ''}`}
            onClick={() => setMode('login')}
          >
            Đăng nhập
          </div>
          <div
            className={`tab-item flex-1 text-center ${mode === 'register' ? 'active' : ''}`}
            onClick={() => setMode('register')}
          >
            Đăng ký
          </div>
        </div>

        {/* Form */}
        <div className="space-y-4">
          <div>
            <label className="text-xs text-[var(--text3)] mb-1.5 block">Tên đăng nhập</label>
            <input
              className="inp"
              placeholder="username"
              value={form.username}
              onChange={e => update('username', e.target.value)}
              onKeyDown={onKey}
              autoFocus
            />
          </div>

          {mode === 'register' && (
            <div>
              <label className="text-xs text-[var(--text3)] mb-1.5 block">
                Email <span className="text-[var(--text3)]">(tùy chọn)</span>
              </label>
              <input
                className="inp"
                placeholder="email@example.com"
                type="email"
                value={form.email}
                onChange={e => update('email', e.target.value)}
                onKeyDown={onKey}
              />
            </div>
          )}

          <div>
            <label className="text-xs text-[var(--text3)] mb-1.5 block">Mật khẩu</label>
            <div className="relative">
              <input
                className="inp pr-10"
                placeholder="••••••••"
                type={showPw ? 'text' : 'password'}
                value={form.password}
                onChange={e => update('password', e.target.value)}
                onKeyDown={onKey}
              />
              <button
                type="button"
                className="absolute right-3 top-1/2 -translate-y-1/2 text-[var(--text3)]
                  hover:text-[var(--text)] transition-colors"
                onClick={() => setShowPw(v => !v)}
              >
                {showPw ? <EyeOff size={14} /> : <Eye size={14} />}
              </button>
            </div>
          </div>

          {mode === 'login' && (
            <div className="text-xs text-[var(--text3)] bg-[var(--bg)] rounded-lg p-3
              border border-[var(--border)]">
              💡 Tài khoản mặc định:&nbsp;
              <span className="text-[var(--accent)] font-mono font-bold">admin / Admin@123</span>
            </div>
          )}

          <button
            className="btn btn-primary w-full justify-center"
            disabled={loading}
            onClick={mode === 'login' ? handleLogin : handleRegister}
          >
            {loading
              ? '⏳ Đang xử lý...'
              : mode === 'login'
                ? <><LogIn size={15} /> Đăng nhập</>
                : <><UserPlus size={15} /> Tạo tài khoản</>
            }
          </button>
        </div>
      </div>
    </div>
  )
}
